<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="content-div">
      <div class="banner-div">
        <div class="banner-title">数字化转型一站式解决方案</div>
        <div class="banner-desc">轻骑兵低代码PaaS平台是专为中大型企业打造的企业级解决方案平台，集成了人工智能、微服务、低代码等先进技术。
          平台结合金现代多年来在企业级技术服务领域的深厚积累，如低代码开发平台、零代码开发平台、融合集成平台、工作流平台和统一门户平台等，为
          企业提供了全方位、多场景、多层次的数字化支持。平台支持根据客户的特殊需求进行高度个性化的定制，每个产品拥有其独特价值，无论是独立使用
          还是组合使用，轻骑兵PaaS平台都能根据客户的规模、IT规划和应用场景的不同，灵活授权，以满足企业的多样化需求。</div>
      </div>
      <div class="content-title1">
        <img src="../assets/img/allProduct/div1.png">
        快速开发能力
      </div>
      <div class="content-content">
        <p class="content-title2">零代码开发</p>
        <table>
          <tr>
            <td>表单设计器</td>
            <td>表格设计器</td>
            <td>流程设计器</td>
          </tr>
          <tr>
            <td>表单权限</td>
            <td>仪表盘</td>
            <td>数据工厂</td>
          </tr>
          <tr>
            <td>数据权限</td>
            <td>API连接</td>
          </tr>
        </table>
      </div>
      <div class="content-content">
        <p class="content-title2">低代码开发</p>
        <table>
          <tr>
            <td>Web表单设计器</td>
            <td>移动表单设计器</td>
            <td>流程设计器</td>
          </tr>
          <tr>
            <td>模型设计器</td>
            <td>主题设计器</td>
            <td>基础服务</td>
          </tr>
          <tr>
            <td>AI智能创建</td>
            <td>高级组件</td>
          </tr>
        </table>
      </div>
      <div class="content-title1">
        <img src="../assets/img/allProduct/div2.png">
        通用能力
      </div>
      <div class="content-content">
        <p class="content-title2">融合集成平台</p>
        <table>
          <tr>
            <td>接口快速开发</td>
            <td>接口编排开发</td>
            <td>数据集成</td>
          </tr>
          <tr>
            <td>消息集成</td>
            <td>接口运维管理</td>
            <td>资产市场</td>
          </tr>
          <tr>
            <td>接口安全治理</td>
          </tr>
        </table>
      </div>
      <div class="content-content">
        <p class="content-title2">统一门户平台</p>
        <table>
          <tr>
            <td>智能工作台</td>
            <td>应用中心</td>
            <td>消息中心</td>
          </tr>
          <tr>
            <td>统一认证</td>
            <td>统一权限</td>
          </tr>
        </table>
      </div>
      <div class="content-content">
        <p class="content-title2">工作流平台</p>
        <table>
          <tr>
            <td>可视化建模</td>
            <td>流程测试</td>
            <td>流程执行</td>
          </tr>
          <tr>
            <td>在线调整</td>
            <td>流程运维</td>
            <td>流程分析</td>
          </tr>
          <tr>
            <td>流程管理</td>
          </tr>
        </table>
      </div>
      <div class="content-title1">
        <img src="../assets/img/allProduct/div3.png">
        智能服务
      </div>
      <div class="content-content">
        <p class="content-title2">OCR能力平台</p>
        <table>
          <tr>
            <td>文字识别</td>
            <td>表格识别</td>
            <td>印章识别</td>
          </tr>
          <tr>
            <td>板式还原</td>
          </tr>
        </table>
      </div>
      <div class="content-content">
        <p class="content-title2">智能问答</p>
        <table>
          <tr>
            <td>自然语言处理</td>
            <td>问答系统</td>
            <td>机器学习</td>
          </tr>
        </table>
      </div>
      <div class="content-content">
        <p class="content-title2">知识图谱引擎</p>
        <table>
          <tr>
            <td>知识推理查询</td>
            <td>智能推荐</td>
            <td>智能检索</td>
          </tr>
        </table>
      </div>
      <div class="content-content">
        <p class="content-title2">低代码专有大模型</p>
        <table>
          <tr>
            <td>智能创建模块</td>
            <td>智能创建数据模型</td>
          </tr>
          <tr>
            <td>智能创建代码片段</td>
            <td>智能生成表单</td>
          </tr>
        </table>
      </div>
      <div class="content-title1">
        <img src="../assets/img/allProduct/div4.png">
        关键特性
      </div>
      <div class="content-content">
        <table>
          <tr>
            <td>可视化开发</td>
            <td>安全可靠</td>
            <td>全面信创</td>
          </tr>
          <tr>
            <td>灵活扩展</td>
            <td>单体/微服务架构</td>
            <td>AI能力</td>
          </tr>
          <tr>
            <td>模型/表单驱动</td>
            <td>多模式开发</td>
          </tr>
        </table>
      </div>
      <div class="content-title1">
        <img src="../assets/img/allProduct/div5.png">
        支撑体系
      </div>
      <div class="content-content">
        <table>
          <tr>
            <td>UI设计规范</td>
            <td>交付能力</td>
            <td>定制化服务</td>
          </tr>
        </table>
      </div>
      <!-- 底部公司信息 -->
      <CompanyInformation @changePracticeMenuShow="handleOpenPractice"></CompanyInformation>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>

import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import ExperienceNow from "./include/ExperienceNow";
import CompanyInformation from "./include/CompanyInformation";
export default {
  name: "AllProductPhone",
  components: {
    PhoneFooter,
    PhoneHeader,
    RightMenu,
    ExperienceNow,
    CompanyInformation
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
    };
  },
  methods: {
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  }
};
</script>

<style scoped>
/* 头部 */
.content-div {width: 100%;margin-top: 52px;}

.banner-div{background: url("../assets/img/allProduct/app-banner-bg.png") no-repeat;background-size: 100% 100%;padding: 10px;padding-bottom: 35px;}
.banner-title{padding: 30px 10px 10px 10px;font-size: 22px;font-weight: bold;text-align: center;margin-bottom: 20px}
.banner-desc{padding: 10px 15px;font-size: 14px;text-align: justify;line-height: 26px;background-color: rgba(255, 255, 255, 0.4);border-radius: 15px;color: #2e2e2e}

.content-title1{margin: 20px 15px;font-size: 16px;font-weight: bold}
.content-content{background: #F4F8FE;margin: 15px 10px;padding: 15px 15px}
.content-title1 img{margin-right: 5px;position: relative;top: 6px}
.content-title2{font-size: 15px;color: #186CF5;font-weight: bold;padding: 5px 0px 10px 0px;border-bottom:1px solid #707070;}
table{width: 100%;font-size: 14px;line-height: 30px;color: #2e2e2e;margin-top: 5px;}
tr{}
</style>



// WEBPACK FOOTER //
// src/components/AllProductPhone.vue